export const onUpdateTrendCursor = (trendCursor) => ({
    type: 'UPDATE_TREND_CURSOR',
    payload: {
        trendCursor,
    },
});
export const updateTrendCursor = ({ trendCursor }, trendCursors) => {
    const { id } = trendCursor;
    return {
        ...trendCursors,
        [id]: trendCursor,
    };
};
